import { render } from "./CompanyContactForm.vue?vue&type=template&id=35f54ae6&scoped=true"
import script from "./CompanyContactForm.vue?vue&type=script&lang=js"
export * from "./CompanyContactForm.vue?vue&type=script&lang=js"

import "./CompanyContactForm.vue?vue&type=style&index=0&id=35f54ae6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35f54ae6"]])

export default __exports__